import { Injectable } from '@angular/core';
import { EshavaControlOptionItem } from 'eshava-controls';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductSelectorService {

  private _isVisible = true;
  private _selectedProductId: number | undefined;
  private _products: EshavaControlOptionItem[] = [];
  private _subjectVisibilityChanged: Subject<boolean> = new Subject<boolean>();
  private _subjectproductRegistered: Subject<EshavaControlOptionItem[]> = new Subject<EshavaControlOptionItem[]>();
  private _subjectproductSelected: Subject<number | undefined> = new Subject<number | undefined>();

  public visibilityChanged$ = this._subjectVisibilityChanged.asObservable();
  public productsRegistered$ = this._subjectproductRegistered.asObservable();
  public productSelected$ = this._subjectproductSelected.asObservable();

  constructor() {

  }

  public get selectedProductId(): number | undefined {
    return this._selectedProductId;
  }

  public get products(): EshavaControlOptionItem[] {
    return this._products;
  }

  public get isVisible(): boolean {
    return this._isVisible;
  }

  public registerProducts(products: EshavaControlOptionItem[]): void {
    this._products = products;
    this._subjectproductRegistered.next(products);
  }

  public onProductSelected(productId: number | undefined): void {
    this._selectedProductId = productId;
    this._subjectproductSelected.next(productId);
  }

  public hide(): void {
    this._isVisible = false;
    this._subjectVisibilityChanged.next(this._isVisible);
  }

  public show(): void {
    this._isVisible = true;
    this._subjectVisibilityChanged.next(this._isVisible);
  }
}
